<template>
  <div>
    <popup
      :opened="showPopup"
      @close="togglePopup(false);"
    >
      <!-- Screen to ask a confirmation to close current evaluation -->
      <div
        v-if="loading"
        class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto flex flex-col items-center justify-center"
      >
        <h3 class="text-center">
          Préparation de votre reçu...
        </h3>
        <div class="lds-roller my-15">
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
      </div>

      <div
        v-else
        class="mx-5 xl:mx-16 2xl:mx-20 mt-8 w-auto h-full flex flex-col items-center"
      >
        <div class="flex flex-col items-center">
          <h3 class="text-center">
            Votre reçu est prêt !
          </h3>
          <a
            :href="downloadLink"
            :download="filename"
            class="my-15"
          >
            <action-button
              icon="download"
              libelle="TELECHARGER"
              border-color="transparent"
              bg-color="bg-pink-600"
              icon-color="text-white"
              text-color="text-white"
            />
          </a>
        </div>

        <illustration name="Group189" />
        <h3 class="text-center text-sm italic text-pink-600 mt-5">
          Un problème avec le téléchargement ?<br>
          <span class="not-italic text-indigo-600 underline"><a
            :href="hostedInvoiceUrl"
            target="_blank"
          >Cliquez ici</a></span>
        </h3>
      </div>
    </popup>

    <div
      v-if="allowed && $subscribed()"
      class="my-15"
    >
      <div class="grid grid-cols-12 gap-x-4 mb-10 text-gray-600 text-lg">
        <div class="col-span-2 pl-8">
          Période
        </div>
        <div class="col-span-4">
          Type d'offre
        </div>
        <div class="col-span-3">
          Date de prélèvement
        </div>
        <div class="col-span-1">
          Montant
        </div>
        <div class="col-span-1">
          Télécharger
        </div>
      </div>


      <div
        v-for="(invoice, invoiceIdx) in invoicesSortedByDate"
        :key="invoiceIdx"
        class="grid grid-cols-12 gap-x-4 even:bg-indigo-200 even:bg-opacity-50 h-24 content-center items-center text-base"
      >
        <div class="col-span-2 pl-8">
          {{ invoiceFormatDate(invoice.lines.data[0].period.start) }} - {{ invoiceFormatDate(invoice.lines.data[0].period.end) }}
        </div>
        <div class="col-span-4">
          <tag
            theme-color="indigo"
            :libelle="'Standard: abonnement de '+invoice.lines.data[0].quantity+' Neopass'"
            text-size="text-md"
          />
        </div>
        <div class="col-span-3">
          {{ invoiceFormatDate(invoice.status_transitions.paid_at) }} 
          {{
            invoice.lines.data[0].plan.interval === 'year' ? '(annuel)' 
            : invoice.lines.data[0].plan.interval === 'month' ? '(mensuel)' : ''
          }}
        </div>
        <div class="col-span-1 font-medium">
          {{ (invoice.total/100).toFixed(2) }} €
        </div>
        <div class="col-span-1">
          <circle-button 
            icon="download" 
            label="Télécharger le reçu" 
            @buttonClick="downloadInvoice(invoice.id, invoiceFormatDate(invoice.status_transitions.paid_at))"
          />
        </div>
      </div>
    </div>
    <div v-else-if="!$subscribed() && !allowed">
      <div class="relative align-middle">
        <h3 class="mt-10 mb-5 w-full">
          Offre Gratuite
        </h3>
        <h6 class="text-gray-600">
          Vous ne disposez pas d'historiques de paiement car vous bénéficiez d'un abonnement gratuit.
        </h6>

        <div class="flex items-center justify-center mt-15">
          <illustration name="notAllowed" />
        </div>
      </div>
    </div>
    <page-not-allowed-without-container v-else-if="!allowed && $subscribed()" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Tag from '../../components/Tag';
import Icon from '../../components/Icon';
import axios from 'axios';
import Popup from '../../components/Popup';
import actionButton from '../../components/ActionButton';
import Illustration from '../../components/Illustration';
import PageNotAllowedWithoutContainer from './../../components/PageNotAllowedWithoutContainer.vue';
import CircleButton from './../../components/CircleButton.vue';

export default {
  name: 'Accountbillinghistory',
  components: {
    Illustration, 
    Icon,
    Tag, 
    Popup, 
    actionButton,
    PageNotAllowedWithoutContainer,
    CircleButton,
  },

  data(){
    return {
      showPopup: false,
      loading: false,
      downloadLink: '',
      hostedInvoiceUrl: '',
      filename: '',
    };
  },
  computed: {
    ...mapGetters({
      invoices: 'account/billingHistory',
      allowed: 'app/allowed',
    }),

    invoicesSortedByDate(){
      const invoiceList = this.invoices;

      let sorted = invoiceList.sort((a, b) => {
        return b.period_end - a.period_end;
      });

      return sorted;
    }
  },

  methods: {
    invoiceFormatDate(date){
      return new Date(date*1000).toLocaleDateString('fr-FR', {year: '2-digit', month: '2-digit', day:'2-digit'});
    },
    async downloadInvoice(id, date){
      this.loading = true;
      this.togglePopup(true);
      await axios.get('/api/invoice/'+id, {responseType: 'blob'}).then((response) => {
        const url = URL.createObjectURL(response.data);
        this.downloadLink = url;
        this.filename = 'Reçu du '+date.replace(/\//g, '-')+'.pdf';
        //window.open(URL.createObjectURL(response.data), 'popup')
      }).catch(error => console.error(error))
        .finally(() => {
          this.loading = false;
          this.hostedInvoiceUrl = this.invoices.filter(invoice => invoice.id === id)[0].hosted_invoice_url;
        });
    },

    togglePopup(value = null){
      if (value === null){
        this.showPopup = !this.showPopup;
      }else {
        this.showPopup = value;
        if(!value){
          this.hostedInvoiceUrl = '';
          this.downloadLink = '';
          this.filename = '';
        }
      }
    }
  }
};
</script>

<style>
.lds-roller {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
}
.lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #FF1C80;
    margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
    top: 63px;
    left: 63px;
    background: #3A18D1;
}
.lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
    top: 68px;
    left: 56px;
}
.lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
    top: 71px;
    left: 48px;
    background: #3A18D1;
}
.lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
    top: 72px;
    left: 40px;
}
.lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
    top: 71px;
    left: 32px;
    background: #3A18D1;
}
.lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
    top: 68px;
    left: 24px;
}
.lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
    top: 63px;
    left: 17px;
    background: #3A18D1;
}
.lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
    top: 56px;
    left: 12px;
}
@keyframes lds-roller {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
